import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface PrimerInformationProps {
  allowFeatureEdits: boolean;
}

export default function PrimerInformation({allowFeatureEdits}: PrimerInformationProps): JSX.Element {
  return (
    <>
      <div className="row">
        <div className="col col-md-12">
          <h5>
            {allowFeatureEdits && (
              <div className="pull-right">
                <a
                  className="edit-primer"
                  {...getTestProps({component: 'PrimerInformation', element: 'editPrimer'})}
                >
                  Edit
                </a>
                <div className="js-detach pull-right">
                  &nbsp;&middot;&nbsp;<a className="detach-primer">Detach</a>
                </div>
              </div>
            )}
            Additional Information
          </h5>
        </div>
      </div>
      <div className="sequence-primer-bases">
        <div className="sequence-primer-bases-inner selectable mono" />
      </div>
      <table className="table primer-info-table">
        <colgroup>
          <col />
          <col className="value" />
        </colgroup>
        <tbody>
          <tr>
            <td>Name</td>
            <td className="selectable">
              <span className="name" />
            </td>
          </tr>
          <tr>
            <td>Folder</td>
            <td>
              <a className="library" />
            </td>
          </tr>
          <tr>
            <td>Length</td>
            <td className="length selectable" />
          </tr>
          <tr>
            <td>GC Content</td>
            <td className="gc selectable" />
          </tr>
          <tr>
            <td>
              Melting Temp.{' '}
              <a className="adjust-tm">
                T<sub>m</sub> Params
              </a>
            </td>
            <td className="melting-temp selectable" />
          </tr>
          <tr>
            <td>Color</td>
            <td>
              <div className="swatch-big" />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="row">
        <div className="col col-md-12">
          <div className="btn-group btn-block dropup">
            <button
              type="button"
              data-toggle="dropdown"
              className="btn btn-af-default btn-block tm-params dropdown-toggle"
            >
              Analyze
              <span className="caret" />
            </button>
            <ul className="dropdown-menu pull-right">
              <li>
                <a className="secondary-analyze">Check Secondary Structure</a>
                <a className="other-binding">Check Specificity</a>
                {BenchlingConfig.MOLBIO_ENABLE_EXTERNAL_BLAST && <a className="blast-primer">NCBI BLAST</a>}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
